import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "bonus-banner"
}

import WheelBanner from "@/wheel-of-fortune/wheel-page/components/win-popup/components/wheel-banner.vue";
import { useObtainableBonus } from "@/composables/use-obtainable-bonus";
import { computed } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'bonus-banner',
  emits: ["closeBonusBanner"],
  setup(__props, { emit: __emit }) {

const emit = __emit;

const { obtainableBonusData, bonusBannerLink, bonusBannerTextShort } = useObtainableBonus();
const bonusBannerVisible = computed<boolean>(() => !!obtainableBonusData.value);

return (_ctx: any,_cache: any) => {
  return (bonusBannerVisible.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(WheelBanner, {
          "is-coin": false,
          text: _unref(bonusBannerTextShort),
          link: _unref(bonusBannerLink)
        }, null, 8, ["text", "link"]),
        _createElementVNode("div", {
          class: "bonus-banner__close",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('closeBonusBanner')))
        })
      ]))
    : _createCommentVNode("", true)
}
}

})